$(document).ready(function() {
  if ($("input[name$='[siren]']").length && $("input[name$='[orias_id]']").length) {
    $("input[name$='[siren]']").keyup(function() {
      if ($(this).val().length === 9 && $("input[name$='[orias_id]']").val() === '') {
        $.ajax({
          url: '/orias_numbers?siren=' + $(this).val(),
          type: 'GET',
          success: function (response) {
           $("input[name$='[orias_id]']").val(response.orias_id)
          }
        });
      }
    });
  }
});
